import axios from "axios";
import { platformGetToken } from "./localStorageHelper";
import { onLogout } from "./utils";
import { toast } from "react-toastify";

export const setupResponseInterceptor = (navigate) => {

    axios.interceptors.response.use(function (response) {
        return response;
      }, async function (error) {
            switch(error.response.status) {
                case 401:
                    if(! toast.isActive("axios-error")) {
                        toast.error(<div><b>{error.response.statusText}</b><br /> {error.message}</div>, {
                            theme: "dark",
                            closeOnClick: false,
                            pauseOnHover: false,
                            draggable: true,
                            toastId: 'axios-error'
                        })
                    }
                    await onLogout()   
                    break;
                default:
                    break;
            }
        return Promise.reject(error);
      });
}


export const getStatisticsFromOrigin = async (url, range = global.config.dashboard.range) => {
    const accessToken = platformGetToken();
    try {
        let response = await axios.get(url + `?range=${range}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken
                }
            }
        )
        return response.data;
    } catch(response) {
        console.error(response.response.status + " - " + response.response.statusText)
    }
}

export const getMetricsFromOrigin = async (url) => {
    const accessToken = platformGetToken();
    try {
        let response = await axios.get(url,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken
                }
            }
        )
        return response.data;
    } catch(response) {
        console.error(response.response.status + " - " + response.response.statusText)
    }
}

export const getCategoryFromOrigin = async (url, category) => {
    const accessToken = platformGetToken();
    try {
        let response = await axios.get(url + `?category=${category}`,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken
                }
            }
        )
        return response.data;
    } catch(response) {
        console.error(response.response.status + " - " + response.response.statusText)
    }
}